const initialStateEcon = {
   menuSel:"Overview",
   contentSel:"Overview",
   econId:"DFF"
   
}

export {initialStateEcon}